module.exports = __webpack_public_path__ + "img/tg-hover.36029424.svg";